import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function NakliyeFiyatlariPage() {
  return (
    <>
      <Helmet>
        <title>Nakliye Fiyatları | KolayYük</title>
        <meta
          name="description"
          content="Nakliye fiyatları; mesafe, yük tipi, tonaj ve araç seçimine göre değişir. KolayYük ile yükünüz için birden fazla nakliyeciden teklif alarak en uygun fiyatı değerlendirin."
        />
        <meta
          name="keywords"
          content="nakliye fiyatları, nakliye ücretleri, şehirler arası nakliye, tır nakliye fiyatı, yük taşıma fiyatları, nakliye teklifi"
        />
        <link rel="canonical" href="https://www.kolayyuk.com/nakliye-fiyatlari" />
      </Helmet>

      <main className="bg-white text-gray-900">
        <section className="border-b border-gray-100 bg-gradient-to-b from-gray-50 to-white">
          <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
            <div className="max-w-4xl">
              <span className="inline-flex rounded-full border border-gray-200 bg-white px-4 py-1 text-sm font-medium text-gray-700">
                KolayYük Rehberi
              </span>

              <h1 className="mt-5 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
                Nakliye Fiyatları Neye Göre Belirlenir?
              </h1>

              <p className="mt-6 text-lg leading-8 text-gray-600">
                Nakliye fiyatları sabit değildir. Taşınacak yükün özellikleri,
                gidilecek mesafe, seçilecek araç tipi, yükleme ve teslimat
                koşulları gibi birçok unsur fiyat üzerinde doğrudan etkili olur.
                Bu nedenle en doğru yaklaşım, tek bir rakama bağlı kalmak yerine
                farklı nakliyecilerden teklif alarak seçenekleri karşılaştırmaktır.
              </p>

              <div className="mt-8 flex flex-wrap gap-4">
                <a
                  href="#teklif-al"
                  className="inline-flex items-center justify-center rounded-2xl bg-black px-6 py-3 text-sm font-semibold text-white transition hover:bg-gray-800"
                >
                  Teklif Alma Yöntemini İncele
                </a>

                <Link
                  to="/"
                  className="inline-flex items-center justify-center rounded-2xl border border-gray-300 px-6 py-3 text-sm font-semibold text-gray-800 transition hover:bg-gray-50"
                >
                  Ana Sayfaya Dön
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-3">
            <article className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-gray-900">
                Mesafe ve Güzergâh
              </h2>
              <p className="mt-3 text-base leading-7 text-gray-600">
                Nakliye ücretlerini etkileyen en temel unsurlardan biri mesafedir.
                Ancak yalnızca kilometre değil; güzergâhtaki otoyol kullanımı,
                köprü geçişleri, trafik yoğunluğu ve bölgesel erişim şartları da
                toplam maliyeti değiştirebilir.
              </p>
            </article>

            <article className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-gray-900">
                Yükün Türü ve Özellikleri
              </h2>
              <p className="mt-3 text-base leading-7 text-gray-600">
                Taşınacak ürünün ağırlığı, hacmi, hassasiyeti ve yükleme şekli
                fiyatı doğrudan etkiler. Standart yüklerle özel taşıma gerektiren
                ürünlerin fiyatlandırması aynı olmayabilir.
              </p>
            </article>

            <article className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-gray-900">
                Araç Tipi ve Taşıma Modeli
              </h2>
              <p className="mt-3 text-base leading-7 text-gray-600">
                Tır, kamyon, kamyonet ya da farklı dorse tipleri arasında maliyet
                farkı oluşabilir. Ayrıca yükün komple taşınması ile parsiyel
                taşınması arasında da fiyat değişebilir.
              </p>
            </article>
          </div>
        </section>

        <section className="bg-gray-50">
          <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                Nakliye Fiyatlarını Etkileyen Başlıca Unsurlar
              </h2>
              <p className="mt-4 text-lg leading-8 text-gray-600">
                Nakliye fiyatları değerlendirilirken aşağıdaki unsurlar birlikte
                düşünülmelidir. Bu nedenle internette görülen tek bir fiyat
                çoğu zaman her yük için geçerli olmaz.
              </p>
            </div>

            <div className="mt-10 grid gap-6 md:grid-cols-2">
              {[
                {
                  title: "Yükleme ve boşaltma noktaları",
                  text: "Şehir içi erişim, bölgesel yoğunluk, sanayi bölgesi veya kırsal teslimat gibi koşullar fiyatı değiştirebilir.",
                },
                {
                  title: "Tonaj ve hacim",
                  text: "Aynı mesafede bile hafif ve hacimli yük ile ağır yükün maliyeti farklı olabilir.",
                },
                {
                  title: "Teslim süresi",
                  text: "Acil taşıma talepleri veya belirli saat aralıklarında teslimat istenmesi fiyatı etkileyebilir.",
                },
                {
                  title: "Araç uygunluğu",
                  text: "Tenteli, frigorifik, damperli ya da farklı taşıma ekipmanları gerektiğinde teklif değişebilir.",
                },
                {
                  title: "Parsiyel veya komple taşıma",
                  text: "Yükün tamamı için araç tutmak ile parsiyel taşıma seçeneği arasında ciddi fark oluşabilir.",
                },
                {
                  title: "Sezonsallık ve piyasa koşulları",
                  text: "Bazı dönemlerde talep artışı, rota yoğunluğu ve araç bulunabilirliği fiyatların değişmesine neden olabilir.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm"
                >
                  <h3 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-7 text-gray-600">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-2">
            <div>
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                Neden Tek Bir Fiyata Güvenmek Doğru Değildir?
              </h2>
              <p className="mt-5 text-base leading-8 text-gray-600">
                “Nakliye fiyatı ne kadar?” sorusunun tek bir cevabı yoktur.
                Çünkü her taşıma işi kendi içinde farklı detaylara sahiptir.
                Aynı şehirler arasında yapılacak iki taşıma bile yük tipi,
                araç ihtiyacı, çıkış zamanı ve teslim koşullarına göre farklı
                teklifler alabilir.
              </p>
              <p className="mt-4 text-base leading-8 text-gray-600">
                Bu yüzden sabit bir rakam aramak yerine, yükünüze özel teklif
                toplamak çok daha doğru bir yöntemdir. Böylece hem piyasa
                koşullarını daha net görür hem de size en uygun seçeneği
                değerlendirme fırsatı elde edersiniz.
              </p>
            </div>

            <div className="rounded-3xl border border-gray-200 bg-white p-8 shadow-sm">
              <h3 className="text-2xl font-bold text-gray-900">
                En sağlıklı yöntem nedir?
              </h3>
              <ul className="mt-6 space-y-4 text-base leading-7 text-gray-600">
                <li>
                  Yük bilgilerinizi net şekilde girin.
                </li>
                <li>
                  Güzergâhı ve taşıma detaylarını doğru belirtin.
                </li>
                <li>
                  Birden fazla nakliyeciden teklif alın.
                </li>
                <li>
                  Sadece fiyatı değil, uygunluk ve taşıma koşullarını da karşılaştırın.
                </li>
                <li>
                  İhtiyacınıza en uygun teklifi seçin.
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="bg-black text-white">
          <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                KolayYük ile Tek Tek Aramak Yerine Teklifleri Toplayın
              </h2>
              <p className="mt-5 text-lg leading-8 text-gray-300">
                Nakliye sürecinde en zorlayıcı konulardan biri, uygun taşıyıcıyı
                bulmak ve fiyat karşılaştırmasını sağlıklı şekilde yapabilmektir.
                KolayYük, bu süreci daha pratik hale getirmek için geliştirildi.
              </p>
              <p className="mt-4 text-lg leading-8 text-gray-300">
                Yük bilgilerinizi oluşturduğunuzda, uygulama üzerinden birçok
                nakliyeciden teklif alabilir; gelen teklifleri karşılaştırarak
                sizin için en uygun seçeneği değerlendirebilirsiniz.
              </p>
            </div>
          </div>
        </section>

        <section id="teklif-al" className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="overflow-hidden rounded-[32px] bg-gradient-to-r from-gray-900 to-black px-6 py-10 sm:px-10 lg:px-12">
            <div className="max-w-4xl">
              <span className="inline-flex rounded-full bg-white/10 px-4 py-1 text-sm font-medium text-white">
                KolayYük Uygulaması
              </span>

              <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                Yükünüz için birden fazla nakliyeciden fiyat teklifi alın
              </h2>

              <p className="mt-5 text-lg leading-8 text-gray-200">
                Nakliye fiyatları değişken olduğu için en doğru yöntem, yükünüze
                özel teklif toplamaktır. KolayYük’ü indirerek yükünüzü oluşturabilir,
                birçok nakliyeciden gelen teklifleri karşılaştırabilir ve süreci
                daha kontrollü şekilde yönetebilirsiniz.
              </p>

              <p className="mt-4 text-base leading-7 text-gray-300">
                Sabit bir rakama bağlı kalmak yerine, gerçek taşıma koşullarınıza
                uygun teklifleri görmek daha doğru karar vermenizi sağlar.
              </p>

              <div className="mt-8 flex flex-wrap gap-4">
                <Link
  to="/indir"
  className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-3 text-sm font-semibold text-black transition hover:bg-gray-100"
>
  App Store’dan İndir
</Link>

<Link
  to="/indir"
  className="inline-flex items-center justify-center rounded-2xl border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/10"
>
  Google Play’den İndir
</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}